export const ANALYTICS_SOURCE = 'byline-connections';
export const ASK_ROVO_ACTION_SUBJECT_ID = 'teamworkGraphAskRovo';
export const AT_A_GLANCE_ACTION_SUBJECT_ID = 'teamworkGraphAtAGlance';
export const BYLINE_ACTION_SUBJECT_ID = 'teamworkGraphByline';
export const CONNECTION_ROW_ACTION_SUBJECT_ID = 'teamworkGraphConnectionRow';
export const CONNECTION_ROW_PREVIEW_ACTION_SUBJECT_ID = 'teamworkGraphConnectionRowPreview';
export const INCOMING_LINKS_ACTION_SUBJECT = 'incomingLinks';
export const INCOMING_LINKS_LOAD_MORE_ACTION_SUBJECT = 'incomingLinksLoadMore';
export const MENU_CLOSE_ACTION_SUBJECT_ID = 'connectionsBylineMenuClose';
export const MENU_SOURCE = 'connectionsBylineMenu';
export const MODAL_ACTION_SUBJECT_ID = 'teamworkGraphModal';
export const MODAL_CLOSE_ACTION_SUBJECT_ID = 'teamworkGraphModalClose';
export const OPEN_GRAPH_ACTION_SUBJECT_ID = 'teamworkGraphOpenGraph';
export const PAGE_PEOPLE_ACTION_SUBJECT = 'pagePeople';
export const PEOPLE_AND_AGENTS_ROW_ACTION_SUBJECT_ID = 'teamworkGraphPeopleAndAgentsRow';
export const PEOPLE_AND_AGENTS_SHOW_MORE_ACTION_SUBJECT_ID = 'teamworkGraphPeopleAndAgentsShowMore';
export const RELATED_CONTENT_ACTION_SUBJECT = 'relatedContent';
export const SCROLL_RESULT_ACTION_SUBJECT_ID = 'connectionsBylineMenuItemScroll';
export const SHARE_CONTEXT_ACTION_SUBJECT_ID = 'teamworkGraphShareContext';
export const SHARE_CONTEXT_CLOSE_ACTION_SUBJECT_ID = 'teamworkGraphShareContextClose';
export const SHARE_CONTEXT_COPY_ACTION_SUBJECT_ID = 'teamworkGraphShareContextCopyPrompt';
export const SHARE_CONTEXT_MODAL_ACTION_SUBJECT_ID = 'teamworkGraphShareContextModal';
export const SHARE_CONTEXT_TOOL_ACTION_SUBJECT_ID = 'teamworkGraphShareContextTool';

export type SmartLinkScrollResult = 'success' | 'not_found' | 'scroll_error';
